import { useCallback, useRef } from "react";
import { insertAtCaret } from "../utils/insertAtCaret";
import { HandleSetExpressionParameter } from "./useAdvancedEditor";

type SetExpressionParameters = {
  inputValue: string;
  isSettingCursor?: boolean;
};

export const usePrintControls = (handleSetExpression: HandleSetExpressionParameter) => {
  const refElement = useRef(null);

  const setExpression = useCallback(
    ({ inputValue, isSettingCursor }: SetExpressionParameters) => {
      const expression = insertAtCaret(refElement.current, inputValue, isSettingCursor);

      handleSetExpression(expression);
    },
    [handleSetExpression, refElement.current],
  );

  const printSymbol = useCallback(
    (symbol: string) => () => {
      setExpression({ inputValue: symbol, isSettingCursor: true });
    },
    [setExpression],
  );

  const printOperator = useCallback(
    (operator: string) => () => {
      const inputValue = ` ${operator} `;

      setExpression({ inputValue });
    },
    [setExpression],
  );

  const printNullValue = useCallback(() => {
    setExpression({ inputValue: "{null}" });
  }, [setExpression]);

  const printDate = useCallback(() => {
    setExpression({ inputValue: "#''", isSettingCursor: true });
  }, [setExpression]);

  return {
    refElement,
    setExpression,
    printSymbol,
    printOperator,
    printNullValue,
    printDate,
  };
};
